import {
  cacheTypes
} from '../../../common/dictionary'
import {
  Get,
  Post,
  Put,
  Patch
} from '@/backend/services/base/baseAjax'

const service = params => {
  let api = params.api // api接口
  let type = params.type // 请求方式 Get Post Put 选其一
  let body = params.body // 传入参数
  let config = params.config
  let cacheType = params.cacheType // 缓存机制
  let getQuery = function () {
    // 传入参数处理
    return typeof body == 'function' ? body() : body
  }
  let querying = async function () {
    // 请求接口
    result.loading = true
    let data = null
    if (type == 'Get') {
      data = await Get({
        url: api,
        cacheType: cacheType
      })
    } else if (type == 'Post') {
      data = await Post({
        url: api,
        bodyParam: getQuery(),
        config: config
      })
    } else if (type == 'Put') {
      data = await Put({
        url: api,
        bodyParam: getQuery()
      })
    } else if (type == 'Patch') {
      data = await Patch({
        url: api,
        bodyParam: getQuery()
      })
    } else {
      data = await Get({
        url: api
      })
    }
    result.loading = false
    return data
  }
  let result = {
    loading: false,
    querying: querying
  }
  return result
}
export default service
